<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Alterar senha</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
<!--  <div [formGroup]="form" class="flex justify-between gap-4 items-center mt-3">-->
    <div
      [formGroup]="form"
      class="py-2 px-6 items-center"
    >
      <div class="flex justify-between items-center gap-4 mb-2">
    <mat-form-field
      class="input-tg mt-message-input w-full"
      appearance="outline"
    >
      <mat-label>Senha atual</mat-label>
      <input matInput type="password" formControlName="password" />
    </mat-form-field>
  </div>
      <div class="flex justify-between items-center gap-4">
    <mat-form-field
      class="input-tg mt-message-input w-full"
      appearance="outline"
    >
      <mat-label>Nova senha</mat-label>
      <input matInput  formControlName="newPassword" />
      <mat-hint>Senha deve conter no mínimo 6 caracteres.</mat-hint>
    </mat-form-field>
      </div>
      <div class="flex justify-between items-center gap-4">
    <mat-form-field
      class="input-tg mt-message-input w-full"
      appearance="outline"
    >
      <mat-label>Confirmar nova senha</mat-label>
      <input matInput  formControlName="verifyNewPassword" />
      @if(
        form.get('newPassword')?.value &&
        form.get('verifyNewPassword')?.value.length > 0 &&
        form.get('newPassword')?.value != form.get('verifyNewPassword')?.value){
      <mat-hint class="text-red-900" >A senha digitada diverge da senha nova.</mat-hint>
      }
    </mat-form-field>
  </div>
  </div>
  <div class="flex justify-end">
    <button
      mat-flat-button
      class="btn-tg w-1/5"
      [disabled]="!validForm() || loading"
      (click)="updateItem()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Salvar
      }
    </button>
  </div>
</mat-card>
